import * as React from 'react'
import cx from 'classnames'
import styles from './Checkbox.sass'
import Spinner from 'components/Spinner'
import Icon from 'components/Icon'
import { useBrandingSettings } from 'hooks/branding'

export interface CheckboxProps {
  checked?: boolean | 'indeterminate'
  disabled?: boolean
  loading?: boolean
  onChange?(checked: boolean): unknown
  muteClickEvent?: boolean
  size?: number
  'data-test'?: string
}

export default function Checkbox({
  disabled,
  loading,
  onChange,
  muteClickEvent = false,
  checked = false,
  size = 24,
  'data-test': dataTest,
}: CheckboxProps) {
  const { themePrimary } = useBrandingSettings()
  const change = React.useCallback(() => {
    if (!disabled) {
      onChange?.(checked === 'indeterminate' ? true : !checked)
    }
  }, [onChange, checked, disabled])

  return (
    <span
      role="checkbox"
      aria-disabled={disabled ? 'true' : 'false'}
      aria-checked={
        checked ? (checked === 'indeterminate' ? 'mixed' : 'true') : 'false'
      }
      className={cx(
        styles.root,
        disabled && styles.disabled,
        loading && styles.loading,
      )}
    >
      <input
        className={styles.input}
        type="checkbox"
        checked={checked === true}
        onChange={change}
        onClick={(e) => muteClickEvent && e.stopPropagation()}
        data-test={dataTest}
      />
      {loading ? (
        <Spinner color={themePrimary} size={20} />
      ) : (
        <Icon
          color={themePrimary}
          name={
            checked
              ? checked === 'indeterminate'
                ? 'checkbox-indeterminate'
                : 'checkbox'
              : 'checkbox-blank'
          }
          size={size}
        />
      )}
    </span>
  )
}
